import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'material-ui/Checkbox'

const styles = {
  checkbox: {
    width: 168,
  },
  input: { width: '65px' },
  icon: { fill: 'rgb(117 117 117)' },
  label: {
    color: 'rgb(117 117 117)',
    fontWeight: 'normal',
    textAlign: 'left',
    width: '100%',
  },
}

const AllLocationsCheckbox = ({
  handleCheck,
  checked: locationsChecked,
}) => (
  <Checkbox
    label="Search All Locations"
    checked={locationsChecked}
    onCheck={e => handleCheck(e)}
    style={styles.checkbox}
    inputStyle={styles.input}
    iconStyle={styles.icon}
    labelStyle={styles.label}
  />
)

AllLocationsCheckbox.propTypes = {
  handleCheck: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
}

export default AllLocationsCheckbox



// WEBPACK FOOTER //
// ./src/components/sitewide/Filter/AllLocationsCheckbox.js